import { ZoomStarterMode } from '@nts/std/types';
import type { AggregateMetaDataInterface, ZoomAdvancedOptionsInterface } from '@nts/std/interfaces';
import { ZoomAdvancedOptions } from '../../domain-models/find-options/zoom-advanced-options';
import type { ZoomUIStarterArgsInterface } from '@nts/std/interfaces';

export class ZoomUIStarterArgs implements ZoomUIStarterArgsInterface {

    callerDomainModelName: string;
    callerDomainModelFullName: string;
    options: ZoomAdvancedOptionsInterface;
    requestedDomainModelName: string;
    requestedDomainModelFullName: string;
    zoomStarterMode: ZoomStarterMode;
    aggregateMetaData: AggregateMetaDataInterface;
    isRequestedDomainModelRemote: boolean;
    rootDomainModelName: string;

    constructor(
        aggregateMetaData: AggregateMetaDataInterface,
        requestedDomainModelName: string = null,
        requestedDomainModelFullName: string = null,
        isRemote: boolean,
        callerAggregateMetaData: AggregateMetaDataInterface | null,
        rootDomainModelName: string,
        zoomOptions?: ZoomAdvancedOptionsInterface
    ) {

        const callerDomainModelName = callerAggregateMetaData?.rootMetaData?.name;
        const callerDomainModelFullName = callerAggregateMetaData?.rootMetaData?.fullName;

        this.rootDomainModelName = rootDomainModelName;
        this.aggregateMetaData = aggregateMetaData;
        this.callerDomainModelName = callerDomainModelName;
        this.callerDomainModelFullName = callerDomainModelFullName;

        if (callerDomainModelName == null && requestedDomainModelName != null) {
            this.callerDomainModelName = requestedDomainModelName;
        }

        if (callerDomainModelFullName == null && requestedDomainModelFullName != null) {
            this.callerDomainModelFullName = requestedDomainModelFullName;
        }

        if (zoomOptions == null) {
            zoomOptions = new ZoomAdvancedOptions();
        }
        this.options = zoomOptions;

        this.requestedDomainModelName = requestedDomainModelName;
        this.requestedDomainModelFullName = requestedDomainModelFullName;

        // Verifico se il domain model richiesto è remoto
        if (rootDomainModelName == null) {
            // se non è stato passato il root domain model name, allora il domain model richiesto è remoto
            this.isRequestedDomainModelRemote = true;
        } else {
            this.isRequestedDomainModelRemote = isRemote;
        }

    }
}
